export const REQUEST_CREATE_NOTE = "REQUEST_CREATE_NOTE";
export const CANCEL_CREATE_NOTE = "CANCEL_CREATE_NOTE";
export const REQUEST_EDIT_NOTE = "REQUEST_EDIT_NOTE";
export const CANCEL_EDIT_NOTE = "CANCEL_EDIT_NOTE";
export const REQUEST_DELETE_NOTE = "REQUEST_DELETE_NOTE";
export const CANCEL_DELETE_NOTE = "CANCEL_DELETE_NOTE";

export const requestCreateNote = (kind, kindId) => ({
  type: REQUEST_CREATE_NOTE,
  kind,
  kindId
});
export const cancelCreateNote = (kind, kindId) => ({
  type: CANCEL_CREATE_NOTE,
  kind,
  kindId
})

export const requestEditNote = (noteId) => ({
  type: REQUEST_EDIT_NOTE,
  noteId
});
export const cancelEditNote = (noteId) => ({
  type: CANCEL_EDIT_NOTE,
  noteId
})

export const requestDeleteNote = (noteId) => ({
  type: REQUEST_DELETE_NOTE,
  noteId
});
export const cancelDeleteNote = (noteId) => ({
  type: CANCEL_DELETE_NOTE,
  noteId
})

